import { FC } from 'react';

import { SelectorCardCarousel } from '../../../components/shared/SelectorCardCarousel';
import { ProductType } from '../../../types';

interface Props {
    productTypes: ProductType[];
    buildHref?: (productType: ProductType) => string;
    activeProductTypeSlug?: string | null;
    testIdPrefix?: string;
}

export const ProductTypesCarousel: FC<Props> = ({
    productTypes,
    buildHref,
    activeProductTypeSlug,
    testIdPrefix,
}) => {
    const items = productTypes.map((productType) => ({
        id: productType.id,
        name: productType.name,
        image: productType.image,
        href: buildHref ? buildHref(productType) : productType.url_path,
        slug: productType.slug,
    }));

    return (
        <SelectorCardCarousel
            items={items}
            activeItemSlug={activeProductTypeSlug}
            testIdPrefix={testIdPrefix}
            variant="compact"
        />
    );
};
